import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import "./PdfPage.css";
import NoData from "./NoData";
import ChartLoader from "./ChartLoader";

const chunkArray = (array, chunkSize) => {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};

const PdfFifteen = forwardRef((props, ref) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const [refreshDate, setRefreshDate] = useState("");
  const [packWiseCData, setPackWiseCData] = useState([]);
  const tableRefs = useRef([]);
  useEffect(() => {
    fetchData(
      {
        url:
          API_URL_MAIN + "energy_analysis_bus/energy_analysis_refreshdate_bus",
        body: {},
      },
      refreshDateData
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/packwisetemp",
        body: { filterdata: gloablfilter, pack: props.selectTemp },
      },
      appyDataC
    );
  }, [gloablfilter, props.selectTemp]);

  const refreshDateData = (data) => {
    setRefreshDate(data.value_as_string);
  };

  const appyDataC = (data) => {
    setPackWiseCData(data);
  };

  const chunks = chunkArray(packWiseCData, 20);
  useImperativeHandle(ref, () => ({
    getDataForSlide: () => ({
      chunks,
      tableRefs,
    }),
  }));
  return (
    <div className="forteenpage">
      <div className="row" style={{ justifyContent: "end" }}>
        <img
          src="../../../assets/img_Bus/Pdf_Page/Tatamotors.png"
          alt=""
          style={{ height: "80px", width: "250px" }}
        />
      </div>
      <div
        className="row mt-4"
        style={{
          color: "#002060",
          paddingLeft: "60px",
          fontSize: "16px",
          fontWeight: "bolder",
        }}
      >
        Pack wise max temperature vehicles (&ge; {props.selectTemp} °C).
      </div>
      <div
        className="col-md-11"
        style={{ paddingLeft: "80px", paddingRight: "10px" }}
      >
        {isLoading ? (
          <ChartLoader />
        ) : packWiseCData.length > 0 ? (
          chunks.map((chunk, chunkIndex) => (
            <div>
              <div
                ref={tableRefs}
                key={chunkIndex}
                className={`pdf-page ${
                  chunkIndex === 0 ? "" : "pdf-page-extra-padding"
                }`}
              >
                <div style={{ minHeight: "730px" }}>
                  <table
                    id={`${chunkIndex + 1}st__table_formed`}
                    className="table pdftable"
                    style={{ color: "black" }}
                  >
                    <thead>
                      <tr style={{ backgroundColor: "#44546a", color: "#fff" }}>
                        <th>Vin</th>
                        <th>Reg. No</th>
                        <th>City</th>
                        <th>Depot</th>
                        <th>Pack A</th>
                        <th>Pack B</th>
                        <th>Pack C</th>
                        <th>Pack D</th>
                      </tr>
                    </thead>
                    <tbody>
                      {chunk.map((item, index) => (
                        <tr key={index}>
                          <td>{item.key.vehicleId}</td>
                          <td>{item.key.vehicle_registration_number}</td>
                          <td>{item.key.DLR_ORG_CITY}</td>
                          <td>{item.key.Depot_Name}</td>
                          <td
                            style={{
                              color:
                                item.A_Max_Cell_Temp.value >
                                props.selectTemp - 1
                                  ? "red"
                                  : "black",
                            }}
                          >
                            {item.A_Max_Cell_Temp.value}
                          </td>
                          <td
                            style={{
                              color:
                                item.B_Max_Cell_Temp.value >
                                props.selectTemp - 1
                                  ? "red"
                                  : "black",
                            }}
                          >
                            {item.B_Max_Cell_Temp.value}
                          </td>
                          <td
                            style={{
                              color:
                                item.C_Max_Cell_Temp.value >
                                props.selectTemp - 1
                                  ? "red"
                                  : "black",
                            }}
                          >
                            {item.C_Max_Cell_Temp.value}
                          </td>
                          <td
                            style={{
                              color:
                                item.D_Max_Cell_Temp.value >
                                props.selectTemp - 1
                                  ? "red"
                                  : "black",
                            }}
                          >
                            {item.D_Max_Cell_Temp.value}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="footer">
                  <div className="row sixthbottomcontentnew">
                    <div className="col-md-3">
                      <img
                        src="../../../assets/img_Bus/Pdf_Page/footer.png"
                        alt=""
                        style={{ height: "70px", width: "200px" }}
                      />
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-5">
                      <p
                        style={{
                          fontSize: "11px",
                          paddingTop: "60px",
                          paddingLeft: "10px",
                        }}
                      >
                        Copyright, Confidential, Tata Motors Limited
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div id="max_tem_no_data">
            {" "}
            <NoData />{" "}
          </div>
        )}
      </div>
    </div>
  );
});
export default PdfFifteen;
